import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import Bootstrap from 'bootstrap/dist/css/bootstrap.min.css'
import firebase from 'firebase'

Vue.config.productionTip = false

var firebaseConfig = {
  apiKey: "AIzaSyDvecPPirO_HIrFpNIn_0S1-nDOpUYarRo",
  authDomain: "oph2019-kmitl-c2dac.firebaseapp.com",
  databaseURL: "https://oph2019-kmitl-c2dac.firebaseio.com",
  projectId: "oph2019-kmitl-c2dac",
  storageBucket: "oph2019-kmitl-c2dac.appspot.com",
  messagingSenderId: "926147341207",
  appId: "1:926147341207:web:94cddc39bad6abd3"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

new Vue({
  router,
  store,
  Bootstrap,
  render: h => h(App)
}).$mount('#app')
